import React from "react";
import { Step } from "react-joyride";interface StepWithPath extends Step {
    path: string;
    condition?: 'partner' | 'normal';
    hideOnOverlay?: boolean; // New field to hide steps when overlays are shown
    showOnInit?: boolean; // New field to show steps only when isInit is true
    hideOnInit?: boolean; // New field to hide steps when isInit is true
    hideIfFromScripts?: boolean; // New field to hide step if coming from scripts page
}

export const allSteps: StepWithPath[] = [
    // Getting Started Page Steps
    {
        target: ".add-new-domain-screen-btn-inner",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    rocket_launch
                </i>
                <h4>Add Website Domain</h4>
                <p>
                    Click here to <strong>add a website domain</strong> and kick-start your accessibility journey!
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/getting-started",
        condition: "normal",
        disableBeacon: true,
    },
    {
        target: ".modal.show .modal-body",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    domain_add
                </i>
                <h4>Add Domain Modal</h4>
                <p>
                    Enter your <strong>website URL</strong> in this modal to add your domain and get started with accessibility features.
                </p>
            </div>
        ),
        placement: "center",
        path: "/front/getting-started",
        condition: "normal",
        disableBeacon: true,
    },
    // Dashboard Steps (/front) - Normal users
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    emoji_people
                </i>
                <h2>👋 Welcome!</h2>
                <p>Let's walk you through the main features of your dashboard.</p>
            </div>
        ),
        placement: "center",
        path: "/front",
        condition: "normal",
    },
    {
        target: ".tour-sidebar",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    menu
                </i>
                <h4>Sidebar Navigation</h4>
                <p>
                    Use the sidebar to <strong>navigate between sections</strong> like
                    Dashboard, Domains, Settings, and more.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front",
        condition: "normal",
        //hideOnInit: true,
    },
    {
        target: ".aioa_dashboard-header",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    menu
                </i>
                <h4>Header Navigation</h4>
                <p>
                    Here, you can view your <strong>Current Domain</strong>, <strong>Add New Domains</strong>, switch <strong>Language</strong>, and manage your <strong>Profile Settings</strong>.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front",
        condition: "normal",
        //hideOnInit: true,
    },
    // InitMsgBlock Steps for /front when isInit is true
    // {
    //     target: ".aioa_dashboard-init-msg-block",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 info
    //             </i>
    //             <h4>Website Initialization</h4>
    //             <p>
    //                 This overlay appears when your <strong>website widget is being initialized</strong>. Follow the instructions to complete the setup process.
    //             </p>
    //         </div>
    //     ),
    //     placement: "center",
    //     path: "/front",
    //     showOnInit: true,
    // },
    {
        target: ".tour-scripts",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    description
                </i>
                <h4>Setup Instructions</h4>
                <p>
                    Read these <strong>important setup instructions</strong> carefully. They contain essential information about widget installation.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front",
        showOnInit: true,
        hideIfFromScripts: true, // Hide this step if coming from scripts page
    },
    // {
    //     target: ".aioa_dashboard-widget-code",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     showOnInit: true,
    // },
    // {
    //     target: ".aioa_dashboard-widget-code",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Widget Installation Code</h4>
    //             <p>
    //                 This is your <strong>widget installation script</strong>. Copy this code and paste it into your website's footer section before the closing &lt;/body&gt; tag.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     showOnInit: true,
    // },
    // {
    //     target: ".aioa_dashboard-widget-code-copy-btn",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 content_copy
    //             </i>
    //             <h4>Copy Widget Code</h4>
    //             <p>
    //                 Click this button to <strong>copy the widget installation code</strong> to your clipboard, then paste it into your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front",
    //     showOnInit: true,
    // },
    // {
    //     target: ".tour-code-toggle",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 toggle_on
    //             </i>
    //             <h4>Advanced Code Options</h4>
    //             <p>
    //                 Use the <strong>Advanced Code checkbox</strong> for better performance and click the info button to learn more about advanced code features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     showOnInit: true,
    // },
    // {
    //     target: ".tour-plan-type",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 workspace_premium
    //             </i>
    //             <h4>Plan Type</h4>
    //             <p>
    //                 Here you can view your <strong>current subscription plan</strong>{" "}
    //                 and upgrade if needed.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },

    // {
    //     target: ".tour-Website",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 language
    //             </i>
    //             <h4>Default Domain</h4>
    //             <p>
    //                 This shows your <strong>primary website/domain</strong> connected to
    //                 accessibility services.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-Add-new-domain",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 add_circle
    //             </i>
    //             <h4>Add New Domain</h4>
    //             <p>
    //                 Click here to <strong>add a new website</strong> and start managing
    //                 its accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-Support",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 support_agent
    //             </i>
    //             <h4>Support</h4>
    //             <p>
    //                 Need help? Visit the <strong>Support Center</strong> to explore
    //                 FAQs, guides, or contact our team for quick assistance.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-language",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 translate
    //             </i>
    //             <h4>Language</h4>
    //             <p>
    //                 Easily <strong>switch dashboard language</strong> for better
    //                 accessibility and convenience.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-profile",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 account_circle
    //             </i>
    //             <h4>Profile</h4>
    //             <p>
    //                 Manage your <strong>account settings</strong>, security options, and
    //                 personal details from here.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-title",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 dashboard
    //             </i>
    //             <h4>Dashboard</h4>
    //             <p>
    //                 This is your <strong>dashboard overview</strong> where you can track
    //                 key accessibility insights.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     spotlightPadding: 10,
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    // {
    //     target: ".tour-scripts",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     condition: "normal",
    //     hideOnInit: true,
    // },
    {
        target: ".aioa_dashboard-violations-graph",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    pie_chart
                </i>
                <h4>Accessibility Metrics</h4>
                <p>
                    View your <strong>Accessibility Score</strong>, <strong>Violations Remediated Percentage</strong>, and <strong>Alt Text Remediation Progress</strong> at a glance.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front",
        condition: "normal",
        hideOnInit: true,
    },
    {
        target: ".aioa_dashboard-violations-list",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    list
                </i>
                <h4>Violations List</h4>
                <p>
                    Switch between <strong>Remediated Violations</strong> and <strong>Manual Action Required</strong> violations to track your progress.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front",
        condition: "normal",
        hideOnInit: true,
    },
    {
        target: ".aioa_dashboard-violations-report-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    picture_as_pdf
                </i>
                <h4>PDF Report</h4>
                <p>
                    Download a <strong>comprehensive PDF report</strong> of your website's accessibility status and violations.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front",
        condition: "normal",
        hideOnInit: true,
    },
    // Scripts Page Steps (/front/scripts) - For all users
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    code
                </i>
                <h4>Script Integration Guide</h4>
                <p>Let's help you integrate the accessibility widget on your website.</p>
            </div>
        ),
        placement: "center",
        path: "/front/scripts",
    },
    {
        target: ".tour-scripts",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    description
                </i>
                <h4>Setup Instructions</h4>
                <p>
                    Read these <strong>important setup instructions</strong> carefully. They contain essential information about widget installation.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/scripts",
        showOnInit: true,
    },
    // {
    //     target: ".tour-scripts",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/scripts",
    // },
    // {
    //     target: ".aioa_dashboard-widget-code-copy-btn",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 content_copy
    //             </i>
    //             <h4>Copy Code Button</h4>
    //             <p>
    //                 Click this button to <strong>copy the script</strong> to your clipboard. Then paste it into your website's HTML.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/scripts",
    // },
    // {
    //     target: ".tour-code-toggle",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 toggle_on
    //             </i>
    //             <h4>Advanced Code Option</h4>
    //             <p>
    //                 Enable this for <strong>advanced script version</strong> which loads the widget after page load for better performance.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/scripts",
    // },

    // Widget Settings Page Steps (/front/widget-settings)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    settings
                </i>
                <h4>Widget Settings</h4>
                <p>Customize your widget settings by changing color, icon size, position, text color, language and much more.</p>
            </div>
        ),
        placement: "center",
        path: "/front/widget-settings",
    },
    // {
    //     target: ".aioa_dashboard-widget-settings-wrapper",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 tune
    //             </i>
    //             <h4>Widget Settings Panel</h4>
    //             <p>
    //                 This is your main <strong>widget configuration panel</strong> where you can customize all aspects of your accessibility widget.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },

    {
        target: "[data-tour='widget-icon']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    category
                </i>
                <h4>Widget Icon Type</h4>
                <p>
                    Choose from different <strong>icon styles</strong> for your accessibility widget. Select the one that best matches your website's design.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    // {
    //     target: "[data-tour='widget-icon-size']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 photo_size_select_large
    //             </i>
    //             <h4>Widget Icon Size</h4>
    //             <p>
    //                 Adjust the <strong>size of your widget icon</strong>. Choose from preset sizes or set a custom size that works best for your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    {
        target: "[data-tour='widget-color']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    palette
                </i>
                <h4>Widget Color</h4>
                <p>
                    Customize the <strong>color scheme</strong> of your accessibility widget to match your brand colors and website theme.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    {
        target: "[data-tour='widget-text-color']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    format_color_text
                </i>
                <h4>Custom Text Color</h4>
                <p>
                    Set a <strong>custom text color</strong> for your widget to ensure optimal contrast and readability.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    {
        target: "[data-tour='widget-position']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    open_with
                </i>
                <h4>Widget Position</h4>
                <p>
                    Choose where to <strong>position your widget</strong> on the page. Select from corner positions or set precise position.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    // {
    //     target: "[data-tour='widget-size']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 aspect_ratio
    //             </i>
    //             <h4>Widget Size</h4>
    //             <p>
    //                 Adjust the <strong>overall size</strong> of your accessibility widget interface for optimal user experience.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    //  {
    //     target: "[data-tour='widget-hide-icon']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 visibility
    //             </i>
    //             <h4>Unhide Widget Icon</h4>
    //             <p>
    //                 Configure the <strong>unhide widget icon</strong> that appears when users hide the main accessibility widget.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    {
        target: "[data-tour='widget-language']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    language
                </i>
                <h4>Widget Language</h4>
                <p>
                    Select the <strong>default language</strong> for your accessibility widget interface from the available options.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/widget-settings",
    },
    {
        target: "[data-tour='widget-screen-reader']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    record_voice_over
                </i>
                <h4>Screen Reader Voice</h4>
                <p>
                    Choose the <strong>voice for screen reader</strong> functionality. Preview different voices and select the one that works best.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    // {
    //     target: "[data-tour='widget-live-translation']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 translate
    //             </i>
    //             <h4>Live Translation</h4>
    //             <p>
    //                 Enable <strong>browser-based live translation</strong> to automatically translate your website content for users.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    // {
    //     target: "[data-tour='widget-accessibility-statement']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 description
    //             </i>
    //             <h4>Accessibility Statement Link</h4>
    //             <p>
    //                 Add a link to your <strong>accessibility statement</strong> page to provide users with detailed accessibility information.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    // {
    //     target: "[data-tour='widget-report-problem']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 report_problem
    //             </i>
    //             <h4>Report Problem Link</h4>
    //             <p>
    //                 Provide a link where users can <strong>report accessibility issues</strong> they encounter on your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    // {
    //     target: "[data-tour='widget-visibility']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 visibility_off
    //             </i>
    //             <h4>Widget Visibility</h4>
    //             <p>
    //                 Control the <strong>visibility settings</strong> for your widget across different devices and screen sizes.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    {
        target: "[data-tour='widget-custom-trigger']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    touch_app
                </i>
                <h4>Custom Widget Trigger</h4>
                <p>
                    Set up a <strong>custom trigger element</strong> on your website to open the accessibility widget.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front/widget-settings",
    },
    // {
    //     target: "[data-tour='widget-voice-trigger']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 volume_up
    //             </i>
    //             <h4>Open/Close Sound</h4>
    //             <p>
    //                 Enable <strong>audio feedback</strong> when users open or close the accessibility widget.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    // {
    //     target: "[data-tour='widget-analytics']",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 analytics
    //             </i>
    //             <h4>Analytics Tracking</h4>
    //             <p>
    //                 Configure <strong>Google Analytics and Adobe Analytics</strong> tracking codes to monitor widget usage and accessibility interactions.
    //             </p>
    //         </div>
    //     ),
    //     placement: "right",
    //     path: "/front/widget-settings",
    // },
    // {
    //     target: ".aioa_dashboard-custom-language-select",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 translate
    //             </i>
    //             <h4>Widget Language</h4>
    //             <p>
    //                 Select the <strong>default language</strong> for your accessibility widget interface.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/widget-settings",
    // },
    {
        target: ".widget-layout-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    preview
                </i>
                <h4>Live Preview</h4>
                <p>
                    See a <strong>real-time preview</strong> of how your widget will look with your current settings.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/widget-settings",
    },
    {
        target: "button[type='submit']",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    save
                </i>
                <h4>Save Settings</h4>
                <p>
                    Don't forget to <strong>save your changes</strong> after customizing your widget settings.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/widget-settings",
    },


    // Websites Page Steps (/front/websites) - Normal users only
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    language
                </i>
                <h4>Website Management</h4>
                <p>Learn how to manage all your websites and domains in one place.</p>
            </div>
        ),
        placement: "center",
        path: "/front/websites",
        condition: "normal",
    },
    {
        target: ".aioa_dashboard-website-list-filter-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    filter_list
                </i>
                <h4>Filter & Search</h4>
                <p>
                    Use these <strong>filters and search options</strong> to find specific websites, filter by status, or adjust how many items you see per page.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/websites",
        condition: "normal",
    },
    {
        target: ".aioa_dashboard-table",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    table_view
                </i>
                <h4>Websites Table</h4>
                <p>
                    This table shows all your <strong>registered websites</strong> with their plan details, status, pricing, and management options.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/websites",
        condition: "normal",
    },
    {
        target: ".aioa_dashboard-table-thead",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    view_column
                </i>
                <h4>Table Headers</h4>
                <p>
                    Each column shows different information: <strong>Domain name, Plan type, Status, Price, Date, and Actions</strong> you can perform.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/websites",
        condition: "normal",
    },
    {
        target: ".aioa_dashboard-table-body",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    dns
                </i>
                <h4>Website Entries</h4>
                <p>
                    Each row represents a website. You can <strong>manage plans, view scripts, set as current website</strong>, and perform other actions from here.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/websites",
        condition: "normal",
    },
    // Manage Image Alt Text Page Steps (/front/manage-image-alt-text)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    image
                </i>
                <h4>Manage Image Alt Text</h4>
                <p>Learn how to manage and update alt text for images on your website to improve accessibility.</p>
            </div>
        ),
        placement: "center",
        path: "/front/manage-image-alt-text",
    },
    // {
    //     target: ".aioa_dashboard-init-msg-block",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 info
    //             </i>
    //             <h4>Website Initialization</h4>
    //             <p>
    //                 Your website is still being initialized. <strong>Complete the widget installation</strong> to access image alt text management features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "center",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },
    // {
    //     target: ".aioa_dashboard-init-msg-block-text",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 description
    //             </i>
    //             <h4>Setup Required</h4>
    //             <p>
    //                 Follow the <strong>initialization instructions</strong> to complete your website setup before managing image alt text.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },
    // {
    //     target: ".tour-scripts",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },
    // {
    //     target: ".aioa_dashboard-widget-code",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Widget Installation Code</h4>
    //             <p>
    //                 This is your <strong>widget installation script</strong>. Copy this code and paste it into your website's footer section before the closing &lt;/body&gt; tag.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },
    // {
    //     target: ".aioa_dashboard-widget-code-copy-btn",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 content_copy
    //             </i>
    //             <h4>Copy Widget Code</h4>
    //             <p>
    //                 Click this button to <strong>copy the widget installation code</strong> to your clipboard, then paste it into your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },
    // {
    //     target: ".tour-code-toggle",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 toggle_on
    //             </i>
    //             <h4>Advanced Code Options</h4>
    //             <p>
    //                 Use the <strong>Advanced Code checkbox</strong> for better performance and click the info button to learn more about advanced code features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-image-alt-text",
    //     showOnInit: true,
    // },

    {
        target: ".aioa_dashboard-image-type-list-tab",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    tab
                </i>
                <h4>Image Categories</h4>
                <p>
                    Switch between different <strong>image categories</strong>: AI-recommended alt text, remediated images, decorative images, and other images.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/manage-image-alt-text",
        hideOnInit: true,
    },
    {
        target: ".aioa_dashboard-image-list-filter-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    tune
                </i>
                <h4>Filter Options</h4>
                <p>
                    Use these <strong>filter controls</strong> to adjust items per page and select multiple images at once.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/manage-image-alt-text",
        hideOnInit: true,
    },
    // {
    //     target: ".aioa_dashboard-table",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 view_list
    //             </i>
    //             <h4>Images Table</h4>
    //             <p>
    //                 This table shows all images with their current alt text. You can <strong>select, edit, and mark images as decorative</strong> from here.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-image-alt-text"
    // },
    // {
    //     target: ".aioa_dashboard-table-thead",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 checklist
    //             </i>
    //             <h4>Table Controls</h4>
    //             <p>
    //                 Use the <strong>select all checkbox</strong> to quickly select all images, and learn about decorative images using the info button.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     path: "/front/manage-image-alt-text"
    // },
    // {
    //     target: ".aioa_dashboard-table-body",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 edit
    //             </i>
    //             <h4>Edit Alt Text</h4>
    //             <p>
    //                 Click on any image to view details, edit alt text, or mark it as decorative. <strong>AI-generated suggestions</strong> are provided when available.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-image-alt-text"
    // },

    // Manage Plan Page Steps (/front/manage-plan)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    credit_card
                </i>
                <h4>Manage Plan</h4>
                <p>Learn how to manage your subscription plans, upgrade, and view billing information.</p>
            </div>
        ),
        placement: "center",
        path: "/front/manage-plan",
    },
    {
        target: ".aioa_dashboard-manage-plan",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    dashboard
                </i>
                <h4>Plan Management Dashboard</h4>
                <p>
                    This is your main <strong>plan management area</strong> where you can view current plans and upgrade options.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/manage-plan",
    },
    // {
    //     target: ".aioa_dashboard-upgrade-plan-info-box",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 upgrade
    //             </i>
    //             <h4>Upgrade Options</h4>
    //             <p>
    //                 View available <strong>upgrade plans</strong> with different features, pricing, and pageview limits to suit your needs.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-plan",
    // },
    // {
    //     target: ".aioa_dashboard-plan-info-box",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 info
    //             </i>
    //             <h4>Current Plan Info</h4>
    //             <p>
    //                 View your <strong>current plan details</strong> including pricing, expiration date, and plan features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/manage-plan"
    // },

    // Accessibility Checker Page Steps (/front/accessibility-checker)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    fact_check
                </i>
                <h4>Accessibility Checker</h4>
                <p>Scan your website for ADA and WCAG compliance issues and integrate the checker into your site.</p>
            </div>
        ),
        placement: "center",
        path: "/front/accessibility-checker",
    },
    {
        target: ".compliance-checker",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    search
                </i>
                <h4>Compliance Checker</h4>
                <p>
                    Enter your <strong>website URL</strong> and select a compliance standard to scan for accessibility issues.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/accessibility-checker",
    },
    {
        target: ".scan-form",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    link
                </i>
                <h4>Enter Website URL</h4>
                <p>
                    Type your <strong>website URL</strong> and choose the compliance standard you want to check against.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/accessibility-checker",
    },
    {
        target: ".start-scan-btn",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    play_arrow
                </i>
                <h4>Start Scan</h4>
                <p>
                    Click <strong>Start Scan</strong> to begin analyzing your website for accessibility violations.
                </p>
            </div>
        ),
        placement: "left",
        path: "/front/accessibility-checker",
    },
    {
        target: ".integration-banner",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    integration_instructions
                </i>
                <h4>Integrate Checker</h4>
                <p>
                    Click <strong>Integrate</strong> to embed the accessibility checker directly into your website for your visitors.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/accessibility-checker",
    },

    // Domain Report Page Steps (/front/domain-report) - Partner only
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    insert_chart
                </i>
                <h4>Domain Report</h4>
                <p>View comprehensive accessibility reports and analytics for your client domains.</p>
            </div>
        ),
        placement: "center",
        path: "/front/domain-report",
        condition: "partner"
    },

    {
        target: ".tour-scripts",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    description
                </i>
                <h4>Setup Instructions</h4>
                <p>
                    Read these <strong>important setup instructions</strong> carefully. They contain essential information about widget installation.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/domain-report",
        showOnInit: true,
        condition: "partner"
    },
    // {
    //     target: ".aioa_dashboard-widget-code",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/domain-report",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".aioa_dashboard-widget-code-copy-btn",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 content_copy
    //             </i>
    //             <h4>Copy Widget Code</h4>
    //             <p>
    //                 Click this button to <strong>copy the widget installation code</strong> to your clipboard, then paste it into your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/domain-report",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".tour-code-toggle",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 toggle_on
    //             </i>
    //             <h4>Advanced Code Options</h4>
    //             <p>
    //                 Use the <strong>Advanced Code checkbox</strong> for better performance and click the info button to learn more about advanced code features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/domain-report",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".aioa_dashboard-init-msg-block",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 info
    //             </i>
    //             <h4>Website Initialization</h4>
    //             <p>
    //                 This overlay appears when your <strong>website widget is being initialized</strong>. Follow the instructions to complete the setup process.
    //             </p>
    //         </div>
    //     ),
    //     placement: "center",
    //     path: "/front",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".aioa_dashboard-init-msg-block-text",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 description
    //             </i>
    //             <h4>Setup Instructions</h4>
    //             <p>
    //                 Read these <strong>important setup instructions</strong> carefully. They contain essential information about widget installation.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     path: "/front",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    {
        target: ".tour-scripts",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    description
                </i>
                <h4>Setup Instructions</h4>
                <p>
                    Read these <strong>important setup instructions</strong> carefully. They contain essential information about widget installation.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front",
        showOnInit: true,
        condition: "partner"
    },
    // {
    //     target: ".aioa_dashboard-widget-code",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 code
    //             </i>
    //             <h4>Installation Script</h4>
    //             <p>
    //                 Copy this <strong>installation script</strong> and paste it into
    //                 your website to enable accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".aioa_dashboard-widget-code-copy-btn",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 content_copy
    //             </i>
    //             <h4>Copy Widget Code</h4>
    //             <p>
    //                 Click this button to <strong>copy the widget installation code</strong> to your clipboard, then paste it into your website.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    // {
    //     target: ".tour-code-toggle",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 toggle_on
    //             </i>
    //             <h4>Advanced Code Options</h4>
    //             <p>
    //                 Use the <strong>Advanced Code checkbox</strong> for better performance and click the info button to learn more about advanced code features.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     showOnInit: true,
    //     condition: "partner"
    // },
    {
        target: ".aioa_dashboard-violations-graph",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    pie_chart
                </i>
                <h4>Accessibility Metrics</h4>
                <p>
                    View your <strong>Accessibility Score</strong>, <strong>Violations Remediated Percentage</strong>, and <strong>Alt Text Remediation Progress</strong> at a glance.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/domain-report",
        condition: "partner",
        hideOnInit: true
    },
    {
        target: ".aioa_dashboard-violations-list",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    list
                </i>
                <h4>Violations List</h4>
                <p>
                    Switch between <strong>Remediated Violations</strong> and <strong>Manual Action Required</strong> violations to track your progress.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/domain-report",
        condition: "partner",
        hideOnInit: true
    },
    {
        target: ".aioa_dashboard-violations-report-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    picture_as_pdf
                </i>
                <h4>PDF Report</h4>
                <p>
                    Download a <strong>comprehensive PDF report</strong> of your website's accessibility status and violations.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front/domain-report",
        condition: "partner",
        hideOnInit: true
    },

    // Orders Page Steps (/front/orders)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    receipt_long
                </i>
                <h4>Orders & Billing</h4>
                <p>View your order history, billing information, and manage your payment records.</p>
            </div>
        ),
        placement: "center",
        path: "/front/orders",
    },
    // {
    //     target: ".tour-orders-filter",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 tune
    //             </i>
    //             <h4>Filter Controls</h4>
    //             <p>
    //                 Use these <strong>filter options</strong> to search and organize your order history by domain, status, date range, and items per page.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     path: "/front/orders",
    // },
    {
        target: ".tour-order-list",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    list_alt
                </i>
                <h4>Orders Table</h4>
                <p>
                    View all your <strong>order details</strong> including order numbers, descriptions, dates, amounts, and payment status.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/orders",
    },
    // {
    //     target: ".tour-orders-table-header",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 table_chart
    //             </i>
    //             <h4>Order Information</h4>
    //             <p>
    //                 Each column shows: <strong>Order #, Description, Date, Amount (USD), Status</strong>, and available actions for each order.
    //             </p>
    //         </div>
    //     ),
    //     placement: "bottom",
    //     path: "/front/orders",
    // },
    // {
    //     target: ".tour-orders-actions-header",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 more_vert
    //             </i>
    //             <h4>Order Actions</h4>
    //             <p>
    //                 This column contains <strong>action buttons</strong> for each order including download invoice and email invoice options.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/orders",
    // },
    // {
    //     target: ".tour-orders-table-body",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 receipt
    //             </i>
    //             <h4>Order Entries</h4>
    //             <p>
    //                 Each row represents an order. You can <strong>download invoices, email invoices</strong>, and retry failed payments from the actions column.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front/orders",
    // },
    {
        target: ".tour-order-actions",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    smart_button
                </i>
                <h4>Invoice Actions</h4>
                <p>
                    Use these buttons to <strong>download PDF invoices</strong> or <strong>email invoices</strong> directly to your email address.
                </p>
            </div>
        ),
        placement: "left",
        path: "/front/orders",
    },
    // {
    //     target: ".tour-download-invoice",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 download
    //             </i>
    //             <h4>Download Invoice</h4>
    //             <p>
    //                 Click this button to <strong>download the PDF invoice</strong> for this order directly to your device.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/orders",
    // },
    // {
    //     target: ".tour-email-invoice",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 mail
    //             </i>
    //             <h4>Email Invoice</h4>
    //             <p>
    //                 Click this button to <strong>send the invoice via email</strong>. You can specify the email address where you want to receive it.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/orders",
    // },

    // Partner Dashboard Steps (/front) - Partner specific
    {
        target: ".add-new-domain-screen-btn-inner",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    rocket_launch
                </i>
                <h4>Add Website Domain</h4>
                <p>
                    Click here to <strong>add a website domain</strong> and kick-start your accessibility journey!
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/getting-started",
        condition: "partner",
        disableBeacon: true,
    },
    {
        target: ".modal.show .modal-body",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    domain_add
                </i>
                <h4>Add Domain Modal</h4>
                <p>
                    Enter your <strong>website URL</strong> in this modal to add your domain and get started with accessibility features.
                </p>
            </div>
        ),
        placement: "center",
        path: "/front/getting-started",
        condition: "partner",
        disableBeacon: true,
    },
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    emoji_people
                </i>
                <h2>👋 Welcome Partner!</h2>
                <p>Let's walk you through your partner dashboard features.</p>
            </div>
        ),
        placement: "center",
        path: "/front",
        condition: "partner",
    },
    // {
    //     target: ".tour-plan-type",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 workspace_premium
    //             </i>
    //             <h4>Plan Type</h4>
    //             <p>
    //                 Here you can view your <strong>current subscription plan</strong>{" "}
    //                 and upgrade if needed.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front",
    //     condition: "partner",
    // },
    {
        target: ".tour-sidebar",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    menu
                </i>
                <h4>Sidebar Navigation</h4>
                <p>
                    Use the sidebar to <strong>navigate between sections</strong> like
                    Dashboard, Domains, Settings, and more.
                </p>
            </div>
        ),
        placement: "right",
        path: "/front",
        condition: "partner",
    },
    {
        target: ".aioa_dashboard-header",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    menu
                </i>
                <h4>Header Navigation</h4>
                <p>
                    Here, you can view your <strong>Current Domain</strong>, <strong>Add New Domains</strong>, switch <strong>Language</strong>, and manage your <strong>Profile Settings</strong>.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front",
        condition: "partner",
        // hideOnInit: true,
    },
    // {
    //     target: ".tour-Website",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 language
    //             </i>
    //             <h4>Default Domain</h4>
    //             <p>
    //                 This shows your <strong>primary website/domain</strong> connected to
    //                 accessibility services.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "partner",
    // },
    // {
    //     target: ".tour-Add-new-domain",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 add_circle
    //             </i>
    //             <h4>Add New Domain</h4>
    //             <p>
    //                 Click here to <strong>add a new website</strong> and start managing
    //                 its accessibility features.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "partner",
    // },
    // {
    //     target: ".tour-Support",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 support_agent
    //             </i>
    //             <h4>Support</h4>
    //             <p>
    //                 Need help? Visit the <strong>Support Center</strong> to explore
    //                 FAQs, guides, or contact our team for quick assistance.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     condition: "partner",
    // },
    // {
    //     target: ".tour-language",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 translate
    //             </i>
    //             <h4>Language</h4>
    //             <p>
    //                 Easily <strong>switch dashboard language</strong> for better
    //                 accessibility and convenience.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "partner",
    // },
    // {
    //     target: ".tour-profile",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 account_circle
    //             </i>
    //             <h4>Profile</h4>
    //             <p>
    //                 Manage your <strong>account settings</strong>, security options, and
    //                 personal details from here.
    //             </p>
    //         </div>
    //     ),
    //     path: "/front",
    //     condition: "partner",
    // },
    {
        target: ".partner-user-dashboard-block",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    business
                </i>
                <h4>Partner Dashboard</h4>
                <p>
                    This is your <strong>partner dashboard overview</strong> where you can manage client accounts, view analytics, and access partner-specific features.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front",
        condition: "partner",
    },
    {
        target: ".tour-partner-filter-wrapper",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    filter_list
                </i>
                <h4>Filter & Search</h4>
                <p>
                    Use these <strong>filters and search options</strong> to find specific client domains, filter by status, or adjust items per page.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front",
        condition: "partner",
    },
    {
        target: ".tour-partner-table",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    table_view
                </i>
                <h4>Client Domains Table</h4>
                <p>
                    This table shows all your <strong>client domains</strong> with their plan details, status, pricing, and management options.
                </p>
            </div>
        ),
        placement: "top",
        path: "/front",
        condition: "partner",
    },
    // {
    //     target: ".tour-partner-table-body",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 dns
    //             </i>
    //             <h4>Client Domain Entries</h4>
    //             <p>
    //                 Each row represents a client domain. You can <strong>manage plans, edit domains, delete domains</strong>, and access widget settings.
    //             </p>
    //         </div>
    //     ),
    //     placement: "top",
    //     path: "/front",
    //     condition: "partner",
    // },
    // Modify Accessibility Menu Page Steps (/front/addon-services/modify-accessibility-menu)
    {
        target: "body",
        content: (
            <div className="tour-intro">
                <i className="material-symbols-outlined" aria-hidden="true">
                    tune
                </i>
                <h4>Modify Accessibility Menu</h4>
                <p>Customize your accessibility widget menu by enabling/disabling features, reordering items, and configuring language options.</p>
            </div>
        ),
        placement: "center",
        path: "/front/addon-services/modify-accessibility-menu",
    },
    // {
    //     target: ".tour-modify-menu-grid",
    //     content: (
    //         <div>
    //             <i className="material-symbols-outlined" aria-hidden="true">
    //                 dashboard
    //             </i>
    //             <h4>Menu Configuration Dashboard</h4>
    //             <p>
    //                 This dashboard allows you to <strong>customize all aspects</strong> of your accessibility widget menu including main buttons, languages, profiles, and other options.
    //             </p>
    //         </div>
    //     ),
    //     placement: "left",
    //     path: "/front/addon-services/modify-accessibility-menu",
    // },
    {
        target: ".tour-main-menu-card",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    menu
                </i>
                <h4>Main Menu Buttons</h4>
                <p>
                    <strong>Check or Uncheck</strong> accessibility features to enable or disable them, and drag items to reorder how they appear in your widget menu.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/addon-services/modify-accessibility-menu",
    },
    {
        target: ".tour-languages-card",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    language
                </i>
                <h4>Languages Configuration</h4>
                <p>
                    <strong>Check or Uncheck</strong> languages to enable or disable them, and drag to reorder them in your widget. You can turn the toggle off to disable language popup in widget.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/addon-services/modify-accessibility-menu",
    },
    {
        target: ".tour-profiles-card",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    accessibility
                </i>
                <h4>Accessibility Profiles</h4>
                <p>
                    <strong>Check or Uncheck</strong> accessibility profiles to enable or disable them, drag to reorder the profiles.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/addon-services/modify-accessibility-menu",
    },
    {
        target: ".tour-other-options-card",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    settings
                </i>
                <h4>Other Options</h4>
                <p>
                    <strong>Check or Uncheck</strong> additional option to enable or disable them.
                </p>
            </div>
        ),
        placement: "bottom",
        path: "/front/addon-services/modify-accessibility-menu",
    },
    {
        target: ".tour-action-buttons",
        content: (
            <div>
                <i className="material-symbols-outlined" aria-hidden="true">
                    check_circle
                </i>
                <h4>Save or Reset Settings</h4>
                <p>
                    Click <strong>"Save Settings"</strong> to apply your changes, or use
                    <strong> "Reset to Default"</strong> to restore the original accessibility menu configuration.
                </p>
            </div>
        ),
        placement: "auto",
        path: "/front/addon-services/modify-accessibility-menu",
    }
];
